module.exports = __webpack_public_path__ + "img/2001.7d96e01f.png";